import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

export default function FAQ() {
  const faqs = [
    {
      q: "What is Trademarking.ai?",
      a: "Trademarking.ai is an AI-powered platform that helps you check the availability of your trademark and assess potential conflicts with existing trademarks."
    },
    {
      q: "How does the trademark search work?",
      a: "We analyze your proposed trademark against existing trademark databases, checking for similar names, logos, and potential conflicts that could affect your application."
    },
    {
      q: "What's included in the report?",
      a: "The report includes potential trademark conflicts, similarity scores, risk assessment, and recommendations for proceeding with your trademark application."
    },
    {
      q: "How much does it cost?",
      a: "$49, but new users can email hello@trademarking.ai for a discount code."
    },
    {
      q: "How long does it take to get results?",
      a: "Initial results are generated within minutes. A detailed report is delivered to your email shortly after submission."
    },
    {
      q: "Is my information kept confidential?",
      a: "Yes, all submitted trademark information and email addresses are kept strictly confidential and used only for providing our service."
    },
    {
      q: "How accurate are the results?",
      a: "Our AI system provides highly accurate preliminary results, but we recommend consulting with a trademark attorney for final legal advice."
    }
  ];

  return (
    <div className="min-h-screen w-full flex flex-col bg-gradient-to-b from-white to-gray-50">
      <div className="flex-grow flex items-center justify-center p-4">
        <div className="w-full max-w-4xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-12">
            <div className="flex justify-center mb-6">
              <div className="bg-blue-50 text-blue-600 px-4 py-2 rounded-full text-sm font-medium animate-float">
                Powered by AI
              </div>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-8 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Frequently Asked Questions
            </h1>
          </div>

          {/* Main Content Card */}
          <div className="bg-white rounded-3xl shadow-[0_10px_40px_-15px_rgba(0,0,0,0.2)] p-6 md:p-12 mb-12">
            <div className="grid gap-6">
              {faqs.map((faq, index) => (
                <div 
                  key={index} 
                  className="p-6 rounded-[16px] border border-gray-100 hover:border-gray-200 transition-all duration-300 bg-gray-50"
                >
                  <div className="flex items-start gap-4">
                    <div className="mt-1">
                      <HelpCircle className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <h2 className="text-xl font-semibold mb-3 text-gray-900">{faq.q}</h2>
                      <p className="text-gray-600 text-lg">{faq.a}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 text-center">
              <Link 
                to="/" 
                className="inline-flex items-center justify-center px-6 py-3 text-lg font-medium text-blue-600 hover:text-blue-800 transition-colors"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <footer className="bg-white border-t border-gray-100 py-8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-8">
            <div className="flex flex-col md:flex-row gap-4 md:gap-8">
              <Link to="/faq" className="text-gray-600 hover:text-gray-900">FAQ</Link>
              <Link to="/about" className="text-gray-600 hover:text-gray-900">About Trademarking.ai</Link>
              <Link to="/terms" className="text-gray-600 hover:text-gray-900">Terms of Service</Link>
            </div>
          </div>
          
          <div className="text-center">
            <p className="text-lg text-gray-600 font-medium mb-4">
              <strong>COMING SOON:</strong> Generative domain and trademark names, optimized for risk and branding power
            </p>
            <div className="text-sm text-gray-500">
              Copyright © 2025 Sharpe Idea Studio
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}